import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Overview from 'containers/Overview';

var IndexWrapper = /*#__PURE__*/function (_Component) {
  _inherits(IndexWrapper, _Component);

  var _super = _createSuper(IndexWrapper);

  function IndexWrapper() {
    _classCallCheck(this, IndexWrapper);

    return _super.apply(this, arguments);
  }

  _createClass(IndexWrapper, [{
    key: "render",
    value: function render() {
      if (this.props.currentUser == null) {
        return /*#__PURE__*/React.createElement("div", null);
      } else {
        var typeRaw = this.props.currentUser.schools.getActiveSchool(this.props.currentUser.userId).type;
        var type = typeRaw ? typeRaw.toUpperCase() : "";
        return /*#__PURE__*/React.createElement(Overview, null);
      }
    }
  }]);

  return IndexWrapper;
}(Component);

function mapStateToProps(state) {
  return {
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps)(IndexWrapper);